const HISTORY_PATH = 'emailDashboard/sentMail';
const STO_REGEX = new RegExp('^[0-9]{2}[h]$');
const TZO_REGEX = new RegExp('^([0-9]{2}:[0-9]{2}|([0-9]{2}:[0-9]{2}(AM|PM)))$');

export {
    HISTORY_PATH,
    STO_REGEX,
    TZO_REGEX,
};